// util.ts
import moment from 'moment'

export interface DateRet {
  year: number;
  month: number;
  date: number;
  showDate?: number;
}

export interface Iprops {
  handleMouseEnter?(date: DateRet): void;
  handleClick?(date: DateRet): void;
  // 渲染每格
  dateCellRender?(date: DateRet): React.ReactElement;
  // 面板变化
  onPanelChange?(date: DateRet): void;
  currentMonth?: any
  currentYear?:any
  //查询数据类型
  dataType?: any,
  //父组建刷新回调
  onRefresh?(date: any): void;
  //每个item的任务数
  taskCount?: any,
  //任务集合
  taskList?: any
}

// 星期
export const week: string[] = ['日', '一', '二', '三', '四', '五', '六'];

const nowTime = new Date();

export const nowYear = nowTime.getFullYear();
export const nowMonth = nowTime.getMonth() + 1;

/**
 * 日历日期算法
 * @param year
 * @param month
 */
export function getMonthData(year?: number, month?: number): DateRet[] {
  //定义result变量用来保存最后的结果集
  let result: any[] = [];
  if (!year || !month) {
    let date = new Date();
    year = date.getFullYear();
    month = date.getMonth() + 1; //月份修正
  }
  //获取当前月的第一天，用于计算上月预留天数
  let firstDayOfMonth = new Date(year, month - 1, 1);
  let preMonthDay = firstDayOfMonth.getDay();
  //获取上月的最后一天，本月第0天即为上月最后一天
  let lastDayOfLastMonth = new Date(year, month - 1, 0);
  let lastDateOfLastMonth = lastDayOfLastMonth.getDate();
  //获取本月最后一天，下月第0天即为本月最后一天
  let lastDayOfMonth = new Date(year, month, 0);
  let lastDateOfMonth = lastDayOfMonth.getDate();

  for (let i = 0; i < 6 * 7; i++) {
    // 获取当前排序的日期数,+1是为了修正
    let thisYear: number = year,
      thisMonth: number = month,
      date: number = i + 1 - preMonthDay,
      showDate: number = date;
    if (date <= 0) {
      //如果date小于等于0，则说明是上月预留天数，月和日都要加以修正
      thisMonth -= 1;
      showDate = date + lastDateOfLastMonth;
    } else if (date > lastDateOfMonth) {
      //如果date大于本月最后一天说明为下月预留天数，月和日加以修正
      thisMonth += 1;
      showDate = date - lastDateOfMonth;
    }
    // 修正年月，因为当月份为1时，上月减1为0,需要同时修正月和年
    // 当月份为12时，下月加1为13,需要同时修正年和月
    if (thisMonth === 13) {
      thisMonth = 1
      thisYear += 1
      // (thisMonth = 1), (thisYear += 1);
    }
    if (thisMonth === 0) {
      thisMonth = 12
      thisYear -= 1
      // (thisMonth = 12), (thisYear -= 1);
    }
    result.push({
      year: thisYear,
      month: thisMonth,
      date,
      showDate,
    });
    // console.log(thisYear,thisMonth)
  }
  return result;
}

/**
 * 切换按钮样式
 */
export const btnStyle = {
  fontSize: 20,
  cursor: 'pointer',
};
/**
   * 根据年月返回自然月日期
   * 
   */
export const getNaturalMonthData = (year?: any, month?: any, date?: any) => {
  let startDate: any = moment(`${year}-${month}-${date}`).format('YYYY-MM-DD')
  let days: any = moment(`${year}-${month}`, "YYYY-MM").daysInMonth()
  let result: any = []
  console.log(startDate, days)
  for (let i = 0; i < days; i++) {
    result.push(moment(`${year}-${month}-${i + 1}`).format('YYYY-MM-DD'))
  }
  return result
}
/**
   * 判断这是当前年度第几天
   * basisDate: 依据日期, 默认是当天
   */
export const getDayOfYear = (date: any) => {
  let arr = date.split('-');
  let year:any = new Date(arr[0], 0, 0);
  let mouth:any = new Date(arr[0], arr[1] - 1, arr[2]);
  let nums:any = (year - mouth) / 24 / 60 / 60 / 1000
  let day:any = Math.abs( parseInt(nums));
  //从0天开始数
  return day-1;
}
console.log('getDayOfYear', getDayOfYear('2023-12-31'))
/**
   * 根据一个日期计算出其所在的一周，反正对应一周的相应日期
   * basisDate: 依据日期, 默认是当天
   */
export const calcWeekDate = (basisDate = moment().format('YYYY-MM-DD')) => {
  let weekDate = [];
  //以周日为起点所以加一
  let howWeek = moment(basisDate).day() + 1;   // 获取到依据日期为星期几；0为星期日、6为星期6,
  // 如果今天是周日，则单独处理，往前计算6天
  if (howWeek === 0) {
    let mixins = 0;
    while (mixins <= 6) {
      // 一次减1；即一次减6天，5天... => 获取到了这周的周一、周二、到今天
      weekDate.unshift(moment(basisDate).subtract(mixins, 'days').format('YYYY-MM-DD'));
      mixins++;
    }
    return weekDate;
  }

  let minusNum = 1, addNum = 1;
  // 用今天的日期对应的星期数去往前遍历
  while (minusNum <= howWeek) {
    // 一次减1；即一次减6天，5天... => 获取到了这周的周一、周二、到今天
    weekDate.push(moment(basisDate).subtract(howWeek - minusNum, 'days').format('YYYY-MM-DD'));
    minusNum++;
  }

  // 7 - howWeek 即今天后面要加的天数（一周是7天）
  while (addNum <= (7 - howWeek)) {
    weekDate.push(moment(basisDate).add(addNum, 'days').format('YYYY-MM-DD'));
    addNum++;
  }
  return weekDate;
}
